export default __webpack_public_path__ + "static/media/cabinet1-after-2048w.1cb06dd5.png";